import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { vegaWorkspace } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { PageContext } from '../pageContext';
import { pageContextForPrompt } from '../pageContext';

/**
 * The page the user is looking at right now, or `undefined` when the current
 * page has no useful subject.
 *
 * Read at submit time and frozen into the outgoing prompt, so navigating or
 * re-filtering afterwards never rewrites the context of a question that has
 * already been asked.
 */
export const usePageContext = (): PageContext | undefined => {
  const { pathname, search } = useLocation();
  const workspaceEnabled = vegaWorkspace();
  return useMemo(() => pageContextForPrompt(pathname, search, workspaceEnabled), [pathname, search, workspaceEnabled]);
};
